<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <h2>{{ $t('message.eCommerceV2.nameFormHeading') }}</h2>
      <p v-if="!isFinanceFlow">{{ $t('message.eCommerceV2.nameFormMsg') }}</p>
      <div class="row form-row mt-3 mt-sm-4">
        <div class="col-sm-6">
          <mobialis-text-input-with-validation
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.firstName')"
            v-model="firstName"
            vid="firstName"
            data-cy="firstName"
          ></mobialis-text-input-with-validation>
        </div>
        <div class="col-sm-6">
          <mobialis-text-input-with-validation
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.lastName')"
            v-model="lastName"
            vid="lastName"
            data-cy="lastName"
          ></mobialis-text-input-with-validation>
        </div>
      </div>
      <InfoCard v-if="!isFinanceFlow" class="font-weight-bold text-center mt-4">
        <img class="mr-2 mb-1" :src="require('@/assets/shield-check-blue.svg')" alt="" width="16px" height="16px" />
        {{ $t('message.eCommerceV2.notAffectCredit') }}
      </InfoCard>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import InfoCard from '@/components/InfoCard.vue';

export default {
  name: 'NameForm',
  components: {
    InfoCard,
  },
  data() {
    return {
      firstName: cloneDeep(this.$store.state.user.firstName),
      lastName: cloneDeep(this.$store.state.user.lastName),
    };
  },
  computed: {
    isFinanceFlow() {
      return this.currentSubFlow === 'finance';
    },
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('user/SET_FIRST_NAME', this.firstName);
      this.$store.commit('user/SET_LAST_NAME', this.lastName);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
